import {isEmpty} from "lodash"
import React, {useContext, useEffect, useState} from "react"
import ShelfApi from "~/utils/ShelfApi"
import {InfotextContext} from "../context/InfoTextContext"

import {StatsRow, TextContent, TitleSection} from "~/components/"
import {useTranslation} from "react-i18next"

const HomeView = () => {
  const {t} = useTranslation()
  const {setInfotexts} = useContext(InfotextContext)

  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [informations, setInformations] = useState({})

  useEffect(() => {
    ShelfApi({
      method: "get",
      url: "/dashboard_informations/",
      data: {}
    })
      .then(res => {
        console.log("res", res.data)
        setLoading(false)
        setInformations(res.data)
      })
      .catch(err => {
        setLoading(false)
        setError(err)
      })
    setInfotexts()
  }, [])

  function renderItem(label, object, field, percentage = false) {
    let _number = 0
    if (!loading && !error) {
      _number = informations[object][field]
    }
    return (
      <StatsRow.Item label={label} number={_number} percentage={percentage} />
    )
  }

  return (
    <div>
      <TitleSection>
        <h3>{t("home.title")}</h3>
      </TitleSection>
      <TextContent>
        <p>{t("home.text")}</p>
      </TextContent>
      {!!!isEmpty(informations) && (
        <React.Fragment>
          <StatsRow title={t("home.stats.locations")}>
            {renderItem(t("home.stats.total"), "locations", "all")}
          </StatsRow>
          <StatsRow title={t("home.stats.articles")}>
            {renderItem(
              t("home.stats.toBeStockedIn"),
              "articles",
              "to_be_stocked_in"
            )}
            {renderItem(
              t("home.stats.stockedIn"),
              "articles",
              "inside_warehouse"
            )}
            {renderItem(
              t("home.stats.totalStockedOut"),
              "articles",
              "total_stocked_out"
            )}
          </StatsRow>
        </React.Fragment>
      )}
    </div>
  )
}

export default HomeView



// WEBPACK FOOTER //
// ./src/views/HomeView.js